import { call, put, select } from "redux-saga/effects"

import pvsApi from "../../../api/pvs"
import {
  FETCH_PVS_SUCCESS,
  FETCH_PVS_FAILURE,
  CREATE_PVS_SUCCESS,
  CREATE_PVS_FAILURE,
  UPDATE_PVS_SUCCESS,
  UPDATE_PVS_FAILURE,
  DELETE_PVS_SUCCESS,
  DELETE_PVS_FAILURE,
  FETCH_PVS_DETAILS_SUCCESS,
  FETCH_PVS_DETAILS_FAILURE,
  FETCH_PVS_CATEGORY_SUCCESS,
  FETCH_PVS_CATEGORY_FAILURE,
  CREATE_PVS_CATEGORY_SUCCESS,
  CREATE_PVS_CATEGORY_FAILURE,
  UPDATE_PVS_CATEGORY_SUCCESS,
  UPDATE_PVS_CATEGORY_FAILURE,
  FETCH_PVS_CATEGORY_DETAILS_SUCCESS,
  FETCH_PVS_CATEGORY_DETAILS_FAILURE,
  FETCH_PVS_SUBCATEGORY_SUCCESS,
  FETCH_PVS_SUBCATEGORY_FAILURE,
  CREATE_PVS_SUBCATEGORY_SUCCESS,
  CREATE_PVS_SUBCATEGORY_FAILURE,
  UPDATE_PVS_SUBCATEGORY_SUCCESS,
  UPDATE_PVS_SUBCATEGORY_FAILURE,
  FETCH_PVS_SUBCATEGORY_DETAILS_SUCCESS,
  FETCH_PVS_SUBCATEGORY_DETAILS_FAILURE,
  FETCH_PVS_KEYWORD_SUCCESS,
  FETCH_PVS_KEYWORD_FAILURE,
  CREATE_PVS_KEYWORD_SUCCESS,
  CREATE_PVS_KEYWORD_FAILURE,
  UPDATE_PVS_KEYWORD_SUCCESS,
  UPDATE_PVS_KEYWORD_FAILURE,
  FETCH_PVS_KEYWORD_DETAILS_SUCCESS,
  FETCH_PVS_KEYWORD_DETAILS_FAILURE,
  FETCH_PVS_BRAND_SUCCESS,
  FETCH_PVS_BRAND_FAILURE,
  ALL_BAZAAR_LIST_FAILURE,
  ALL_BAZAAR_LIST_SUCCESS,
  FETCH_STALL_LIST_SUCCESS,
  FETCH_STALL_LIST_FAILURE,
  GET_BOOKING_LIST_SUCCESS,
  GET_BOOKING_LIST_FAILURE,
  SUBMIT_BOOKING_SUCCESS,
  SUBMIT_BOOKING_FAILURE,
  FETCH_BOOKING_DETAILS_SUCCESS,
  FETCH_BOOKING_DETAILS_FAILURE,
  ADD_BOOKING_PAYMENT_SUCCESS,
  ADD_BOOKING_PAYMENT_FAILURE,
  RESEND_INVOICE_SUCCESS,
  RESEND_INVOICE_FAILURE,
  GET_USER_BILLING_INFO_SUCCESS,
  GET_USER_BILLING_INFO_FAILURE,
  REGENERATE_INVOICE_SUCCESS,
  REGENERATE_INVOICE_FAILURE,
  DOWNLOAD_INVOICES_SUCCESS,
  DOWNLOAD_INVOICES_FAILURE,
  DOWNLOAD_BOOKING_REPORT_SUCCESS,
  DOWNLOAD_BOOKING_REPORT_FAILURE,
  DOWNLOAD_BALANCE_REPORT_SUCCESS,
  DOWNLOAD_BALANCE_REPORT_FAILURE,
  GET_PVS_DETAILS_FAILURE,
  GET_PVS_DETAILS_SUCCESS,
  FETCH_KEYWORDS_SUCCESS,
  FETCH_KEYWORDS_FAILURE,
  UPDATE_PVS_REGISTRATION_SUCCESS,
  UPDATE_PVS_REGISTRATION_FAILURE,
  VERIFY_PVS_REGISTRATION_PAYMENT_FAILURE,
  VERIFY_PVS_REGISTRATION_PAYMENT_SUCCESS,
  GET_BAZAAR_STALL_DETAILS_SUCCESS,
  GET_BAZAAR_STALL_DETAILS_FAILURE,
  UPDATE_BAZAAR_STALL_DETAILS_FAILURE,
  UPDATE_BAZAAR_STALL_DETAILS_SUCCESS,
  ADD_BAZAAR_SUCCESS,
  ADD_BAZAAR_FAILURE,
  ADD_BAZAAR_STALL_DETAILS_FAILURE,
  ADD_BAZAAR_STALL_DETAILS_SUCCESS,
  CANCEL_STALL_BOOKING_SUCCESS,
  CANCEL_STALL_BOOKING_FAILURE,
  GET_PAYMENT_STATISTICS_SUCCESS,
  GET_PAYMENT_STATISTICS_FAILURE,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_FAILURE,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAILURE,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAILURE,
  FETCH_PRODUCT_DETAILS_SUCCESS,
  FETCH_PRODUCT_DETAILS_FAILURE,
} from "../../types/pvs"

// Helper function to get auth token
const getAuthToken = state => state.auth.token

// Worker Sagas

export function* fetchKeywordsWorker(action) {
  try {
    console.log("fetchKeywordsWorker called with:", action)
    const token = yield select(getAuthToken)
    const response = yield pvsApi.addAwardNomination(action.payload.data, token)
    console.log("fetch keywords response...", response)

    if (response.status === 200 || response.status === 201) {
      yield put({
        type: FETCH_KEYWORDS_SUCCESS,
        payload: {
          details: response.data.data,
          enc_award_nomination_id: response.data.enc_award_nomination_id,
          message: response.message,
        },
      })
    } else {
      yield put({
        type: FETCH_KEYWORDS_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: FETCH_KEYWORDS_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

export function* downloadBookingReportWorker(action) {
  try {
    const response = yield pvsApi.downloadBookingReport(
      action.payload.data,
      action.payload.token
    )
    console.log("download booking report response..", response)

    if (response.status === 200) {
      let successAction = null
      if (action.payload.data.report_type === "excel") {
        successAction = {
          type: DOWNLOAD_BOOKING_REPORT_SUCCESS,
          payload: {
            message:
              response.data.message || "Booking Report Generated Successfully",
            bookingReportFileLink: response.data.fileUrl,
            type: "excel",
          },
        }
      } else {
        successAction = {
          type: DOWNLOAD_BOOKING_REPORT_SUCCESS,
          payload: {
            message:
              response.data.message || "Booking Report Fetched Successfully",
            bookingReport: response.data.data,
            type: "list",
          },
        }
      }
      yield put(successAction)
    } else if (response.status === 404 || response.status === 400) {
      console.log("error response", response)

      let failureAction = {
        type: DOWNLOAD_BOOKING_REPORT_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("download booking report Error", error)
    let failureAction = {
      type: DOWNLOAD_BOOKING_REPORT_FAILURE,
      payload: { error: error.message || "download booking report failed" },
    }
    yield put(failureAction)
  }
}

export function* downloadBalanceReportWorker(action) {
  try {
    const response = yield pvsApi.downloadBalanceReport(
      action.payload.data,
      action.payload.token
    )
    console.log("download balance report response..", response)

    if (response.status === 200) {
      let successAction = null
      if (action.payload.data.report_type === "excel") {
        successAction = {
          type: DOWNLOAD_BALANCE_REPORT_SUCCESS,
          payload: {
            message:
              response.data.message || "Balance Report Generated Successfully",
            balanceReportFileLink: response.data.fileUrl,
            type: "excel",
          },
        }
      } else {
        successAction = {
          type: DOWNLOAD_BALANCE_REPORT_SUCCESS,
          payload: {
            message:
              response.data.message || "Balance Report Generated Successfully",
            balanceReport: response.data.data,
            type: "list",
          },
        }
      }

      yield put(successAction)
    } else if (response.status === 404 || response.status === 400) {
      console.log("error response", response)

      let failureAction = {
        type: DOWNLOAD_BALANCE_REPORT_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("download balance report Error", error)
    let failureAction = {
      type: DOWNLOAD_BALANCE_REPORT_FAILURE,
      payload: { error: error.message || "download balance report failed" },
    }
    yield put(failureAction)
  }
}

export function* updatePvsRegistrationWorker(action) {
  try {
    console.log("updatePvsRegistrationWorker called with:", action)
    const token = yield select(getAuthToken)
    const response = yield pvsApi.updatePvsRegistration(
      action.payload.data,
      token
    )
    console.log("update pvs form response...", response)

    if (response.status === 200 || response.status === 201) {
      yield put({
        type: UPDATE_PVS_REGISTRATION_SUCCESS,
        payload: {
          data: response.data.form_data,
          message: response.message,
        },
      })
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 500
    ) {
      yield put({
        type: UPDATE_PVS_REGISTRATION_FAILURE,
        payload: { message: response.data.message || "Something went wrong" },
      })
    } else {
      yield put({
        type: UPDATE_PVS_REGISTRATION_FAILURE,
        payload: { message: "Something went wrong" },
      })
    }
  } catch (error) {
    yield put({
      type: UPDATE_PVS_REGISTRATION_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

export function* verifyPvsRegistrationWorker(action) {
  try {
    console.log("verifyPvsRegistrationWorker called with:", action)
    const token = yield select(getAuthToken)
    const response = yield pvsApi.verifyPvsRegistrationPayment(
      action.payload.data,
      token
    )
    console.log("verify pvs registration payment response...", response)

    if (response.status === 200 || response.status === 201) {
      yield put({
        type: VERIFY_PVS_REGISTRATION_PAYMENT_SUCCESS,
        payload: {
          details: response.data.data,
          enc_award_nomination_id: response.data.enc_award_nomination_id,
          message: response.message,
        },
      })
    } else {
      yield put({
        type: VERIFY_PVS_REGISTRATION_PAYMENT_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: VERIFY_PVS_REGISTRATION_PAYMENT_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

export function* fetchPvsWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call([pvsApi, "fetchPvs"], token, action.payload)

    // Normalize response
    let responseData = response.data
    if (typeof responseData === "string") {
      try {
        responseData = JSON.parse(responseData)
      } catch (parseError) {
        responseData = {
          success: false,
          error: true,
          message: "Invalid server response",
        }
      }
    }

    if (responseData.error) {
      yield put({
        type: FETCH_PVS_FAILURE,
        payload: { message: responseData.message || "Failed to fetch PVS" },
      })
    } else {
      let payload = {}
      const status = action.payload && action.payload.status
      switch (status) {
        case "approved":
          payload = {
            approved: responseData.pvs || [],
            message: responseData.message,
          }
          break
        case "pending":
          payload = {
            pending: responseData.pvs || [],
            message: responseData.message,
          }
          break
        case "rejected":
          payload = {
            rejected: responseData.pvs || [],
            message: responseData.message,
          }
          break
        case "paid":
          payload = {
            paid: responseData.pvs || [],
            message: responseData.message,
          }
          break
        case "clarification":
          payload = {
            clarification: responseData.pvs || [],
            message: responseData.message,
          }
          break
        default:
          payload = { all: responseData.pvs || [] }
      }
      yield put({
        type: FETCH_PVS_SUCCESS,
        payload,
      })
    }
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong..."

    yield put({
      type: FETCH_PVS_FAILURE,
      payload: { message },
    })
  }
}

export function* createPvsWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call([pvsApi, "createPvs"], token, action.payload)

    if (response.error) {
      yield put({ type: CREATE_PVS_FAILURE, payload: response.error })
    } else {
      yield put({
        type: CREATE_PVS_SUCCESS,
        payload: response.data || response,
      })
    }
  } catch (error) {
    yield put({ type: CREATE_PVS_FAILURE, payload: error.message })
  }
}

export function* updatePvsWorker(action) {
  try {
    const { enc_pvs_entry_id, pvsData } = action.payload
    const token = yield select(getAuthToken)
    const response = yield call(
      [pvsApi, "updatePvs"],
      token,
      enc_pvs_entry_id,
      pvsData
    )
    let responseData = response.data
    if (typeof responseData === "string") {
      try {
        responseData = JSON.parse(responseData)
      } catch {
        responseData = {
          success: false,
          error: true,
          message: "Invalid server response",
        }
      }
    }

    if (responseData.error) {
      yield put({
        type: UPDATE_PVS_FAILURE,
        payload: { message: responseData.message },
      })
    } else {
      yield put({
        type: UPDATE_PVS_SUCCESS,
        payload: responseData.data || responseData,
      })
    }
  } catch (error) {
    yield put({ type: UPDATE_PVS_FAILURE, payload: error.message })
  }
}

export function* deletePvsWorker(action) {
  try {
    const categoryId = action.payload
    const token = yield select(getAuthToken)
    const response = yield call([pvsApi, "deletePvs"], token, categoryId)

    if (response.error) {
      yield put({ type: DELETE_PVS_FAILURE, payload: response.error })
    } else {
      yield put({ type: DELETE_PVS_SUCCESS, payload: categoryId })
    }
  } catch (error) {
    yield put({ type: DELETE_PVS_FAILURE, payload: error.message })
  }
}

export function* getPvsDetailsWorker(action) {
  console.log("getPvsDetailsWorker invoked")

  try {
    const token = yield select(getAuthToken)
    const response = yield pvsApi.getPvsDetails(action.payload.data, token)
    let responseData = response.data
    console.log("responseData", responseData)

    if (responseData.success) {
      yield put({
        type: GET_PVS_DETAILS_SUCCESS,
        payload: { pvsData: responseData.data },
      })
    } else if (responseData.error) {
      yield put({
        type: GET_PVS_DETAILS_FAILURE,
        payload: { message: responseData.message },
      })
    }
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong..."
    yield put({ type: GET_PVS_DETAILS_FAILURE, payload: { message } })
  }
}

/* PVS Category */

export function* fetchPvsCategoryWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [pvsApi, "fetchPvsCategory"],
      token,
      action.payload
    )

    let responseData = response.data
    if (typeof responseData === "string") {
      try {
        responseData = JSON.parse(responseData)
      } catch (e) {
        responseData = {
          success: false,
          error: true,
          message: "Invalid server response",
        }
      }
    }
    if (responseData.error) {
      yield put({
        type: FETCH_PVS_CATEGORY_FAILURE,
        payload: { message: responseData.message },
      })
    } else {
      yield put({
        type: FETCH_PVS_CATEGORY_SUCCESS,
        payload: {
          pvsCategory: responseData.pvsCategory || [],
          message: responseData.message,
        },
      })
    }
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong..."
    yield put({ type: FETCH_PVS_CATEGORY_FAILURE, payload: { message } })
  }
}

export function* createPvsCategoryWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [pvsApi, "createPvsCategory"],
      token,
      action.payload
    )

    let responseData = response.data
    if (typeof responseData === "string") {
      try {
        responseData = JSON.parse(responseData)
      } catch (e) {
        responseData = {
          success: false,
          error: true,
          message: "Invalid server response",
        }
      }
    }

    if (responseData.error) {
      yield put({
        type: CREATE_PVS_CATEGORY_FAILURE,
        payload: { message: responseData.message },
      })
    } else {
      yield put({ type: CREATE_PVS_CATEGORY_SUCCESS, payload: responseData })
    }
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong..."
    yield put({ type: CREATE_PVS_CATEGORY_FAILURE, payload: { message } })
  }
}

export function* updatePvsCategoryWorker(action) {
  try {
    const { enc_pvs_cat_id, pvsData } = action.payload
    const token = yield select(getAuthToken)
    const response = yield call(
      [pvsApi, "updatePvsCategory"],
      token,
      pvsData,
      enc_pvs_cat_id
    )
    let responseData = response.data
    if (typeof responseData === "string") {
      try {
        responseData = JSON.parse(responseData)
      } catch (e) {
        responseData = {
          success: false,
          error: true,
          message: "Invalid server response",
        }
      }
    }
    if (responseData.error) {
      yield put({
        type: UPDATE_PVS_CATEGORY_FAILURE,
        payload: { message: responseData.message },
      })
    } else {
      yield put({
        type: UPDATE_PVS_CATEGORY_SUCCESS,
        payload: { updatePvsData: responseData, message: responseData.message },
      })
    }
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong..."
    yield put({ type: UPDATE_PVS_CATEGORY_FAILURE, payload: { message } })
  }
}

export function* fetchPvsCategoryDetailsWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [pvsApi, "getPvsCategoryDetails"],
      token,
      action.payload
    )
    let responseData = response.data
    if (typeof responseData === "string") {
      try {
        responseData = JSON.parse(responseData)
      } catch (e) {
        responseData = {
          success: false,
          error: true,
          message: "Invalid server response",
        }
      }
    }
    if (responseData.error) {
      yield put({
        type: FETCH_PVS_CATEGORY_DETAILS_FAILURE,
        payload: { message: responseData.message },
      })
    } else {
      yield put({
        type: FETCH_PVS_CATEGORY_DETAILS_SUCCESS,
        payload: {
          pvsCategoryDetail: responseData.data,
          message: responseData.message,
        },
      })
    }
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong..."
    yield put({
      type: FETCH_PVS_CATEGORY_DETAILS_FAILURE,
      payload: { message },
    })
  }
}

/* PVS Subcategory */
export function* fetchPvsSubcategoryWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [pvsApi, "fetchPvsSubcategory"],
      token,
      action.payload
    )
    let responseData = response.data
    if (typeof responseData === "string") {
      try {
        responseData = JSON.parse(responseData)
      } catch (e) {
        responseData = {
          success: false,
          error: true,
          message: "Invalid server response",
        }
      }
    }
    if (responseData.error) {
      yield put({
        type: FETCH_PVS_SUBCATEGORY_FAILURE,
        payload: { message: responseData.message },
      })
    } else {
      yield put({
        type: FETCH_PVS_SUBCATEGORY_SUCCESS,
        payload: {
          pvsSubcategory: responseData.pvsSubcategory || [],
          message: responseData.message,
        },
      })
    }
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong while fetching PVS"
    yield put({ type: FETCH_PVS_SUBCATEGORY_FAILURE, payload: { message } })
  }
}

export function* createPvsSubcategoryWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [pvsApi, "createPvsSubcategory"],
      token,
      action.payload
    )

    // Handle string response (parse if needed)
    let responseData = response.data
    if (typeof responseData === "string") {
      try {
        responseData = JSON.parse(responseData)
      } catch (e) {
        responseData = {
          success: false,
          error: true,
          message: "Invalid server response",
        }
      }
    }

    if (responseData.error) {
      yield put({
        type: CREATE_PVS_SUBCATEGORY_FAILURE,
        payload: { message: responseData.message },
      })
    } else {
      yield put({
        type: CREATE_PVS_SUBCATEGORY_SUCCESS,
        payload: responseData,
      })
    }
  } catch (error) {
    // Axios error handling
    const message =
      error.response?.data?.message || // backend error message
      error.message || // network / js error
      "Something went wrong"

    yield put({
      type: CREATE_PVS_SUBCATEGORY_FAILURE,
      payload: { message },
    })
  }
}

export function* updatePvsSubcategoryWorker(action) {
  try {
    const { enc_pvs_subcat_id, pvsData } = action.payload
    const token = yield select(getAuthToken)
    const response = yield call(
      [pvsApi, "updatePvsSubcategory"],
      token,
      pvsData,
      enc_pvs_subcat_id
    )
    let responseData = response.data
    if (typeof responseData === "string") {
      try {
        responseData = JSON.parse(responseData)
      } catch (e) {
        responseData = {
          success: false,
          error: true,
          message: "Invalid server response",
        }
      }
    }

    if (responseData.error) {
      yield put({
        type: UPDATE_PVS_SUBCATEGORY_FAILURE,
        payload: { message: responseData.message },
      })
    } else {
      yield put({
        type: UPDATE_PVS_SUBCATEGORY_SUCCESS,
        payload: {
          updateSubcategoryData: responseData,
          message: responseData.message,
        },
      })
    }
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong..."
    yield put({ type: UPDATE_PVS_SUBCATEGORY_FAILURE, payload: { message } })
  }
}

export function* fetchPvsSubcategoryDetailsWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [pvsApi, "getPvsSubcategoryDetails"],
      token,
      action.payload
    )
    let responseData = response.data
    if (typeof responseData === "string") {
      try {
        responseData = JSON.parse(responseData)
      } catch (e) {
        responseData = {
          success: false,
          error: true,
          message: "Invalid server response",
        }
      }
    }
    if (responseData.error) {
      yield put({
        type: FETCH_PVS_SUBCATEGORY_DETAILS_FAILURE,
        payload: responseData.message,
      })
    } else {
      yield put({
        type: FETCH_PVS_SUBCATEGORY_DETAILS_SUCCESS,
        payload: {
          pvsSubcategoryDetail: responseData.data,
          message: responseData.message,
        },
      })
    }
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong..."

    yield put({
      type: FETCH_PVS_SUBCATEGORY_DETAILS_FAILURE,
      payload: { message },
    })
  }
}

/* PVS Keyword */

export function* fetchPvsKeywordWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [pvsApi, "fetchPvsKeyword"],
      token,
      action.payload
    )
    let responseData = response.data
    if (typeof responseData === "string") {
      try {
        responseData = JSON.parse(responseData)
      } catch (e) {
        responseData = {
          success: false,
          error: true,
          message: "Invalid server response",
        }
      }
    }

    if (responseData.error) {
      yield put({
        type: FETCH_PVS_KEYWORD_FAILURE,
        payload: { message: responseData.message },
      })
    } else {
      yield put({
        type: FETCH_PVS_KEYWORD_SUCCESS,
        payload: {
          pvsKeyword: responseData.pvsKeyword || [],
          message: responseData.message,
        },
      })
    }
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong..."
    yield put({ type: FETCH_PVS_KEYWORD_FAILURE, payload: { message } })
  }
}

export function* createPvsKeywordWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [pvsApi, "createPvsKeyword"],
      token,
      action.payload
    )
    let responseData = response.data
    if (typeof responseData === "string") {
      try {
        responseData = JSON.parse(responseData)
      } catch (e) {
        responseData = {
          success: false,
          error: true,
          message: "Invalid server response",
        }
      }
    }
    if (responseData.error) {
      yield put({
        type: CREATE_PVS_KEYWORD_FAILURE,
        payload: { message: responseData.message },
      })
    } else {
      yield put({
        type: CREATE_PVS_KEYWORD_SUCCESS,
        payload: {
          data: responseData.data || [],
          message: responseData.message,
        },
      })
    }
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong..."
    yield put({ type: CREATE_PVS_KEYWORD_FAILURE, payload: { message } })
  }
}

export function* updatePvsKeywordWorker(action) {
  try {
    const { pvsData } = action.payload

    const token = yield select(getAuthToken)
    const response = yield call([pvsApi, "updatePvsKeyword"], token, pvsData)
    let responseData = response.data
    if (typeof responseData === "string") {
      try {
        responseData = JSON.parse(responseData)
      } catch (e) {
        responseData = {
          success: false,
          error: true,
          message: "Invalid server response",
        }
      }
    }

    if (response.error) {
      yield put({
        type: UPDATE_PVS_KEYWORD_FAILURE,
        payload: { message: response.message },
      })
    } else {
      yield put({
        type: UPDATE_PVS_KEYWORD_SUCCESS,
        payload: {
          updatePvsKeywordData: responseData,
          message: responseData.message,
        },
      })
    }
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong..."
    yield put({ type: UPDATE_PVS_KEYWORD_FAILURE, payload: { message } })
  }
}

export function* fetchPvsKeywordDetailsWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [pvsApi, "getPvsKeywordDetails"],
      token,
      action.payload
    )
    let responseData = response.data
    if (typeof responseData === "string") {
      try {
        responseData = JSON.parse(responseData)
      } catch (e) {
        responseData = {
          success: false,
          error: true,
          message: "Invalid server response",
        }
      }
    }
    if (responseData.error) {
      yield put({
        type: FETCH_PVS_KEYWORD_DETAILS_FAILURE,
        payload: { message: responseData.message },
      })
    } else {
      yield put({
        type: FETCH_PVS_KEYWORD_DETAILS_SUCCESS,
        payload: {
          pvsKeywordDetail: responseData.data,
          message: responseData.message,
        },
      })
    }
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong..."
    yield put({ type: FETCH_PVS_KEYWORD_DETAILS_FAILURE, payload: { message } })
  }
}

/* PVS Brand */
export function* fetchPvsBrandWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [pvsApi, "fetchPvsBrand"],
      token,
      action.payload
    )
    // Handle string response (parse if needed)
    let responseData = response.data
    if (typeof responseData === "string") {
      try {
        responseData = JSON.parse(responseData)
      } catch (e) {
        responseData = {
          success: false,
          error: true,
          message: "Invalid server response",
        }
      }
    }
    if (responseData.error) {
      yield put({
        type: FETCH_PVS_BRAND_FAILURE,
        payload: { message: responseData.message },
      })
    } else {
      yield put({
        type: FETCH_PVS_BRAND_SUCCESS,
        payload: {
          pvsBrand: responseData.pvsBrand || [],
          message: responseData.message,
        },
      })
    }
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong..."
    yield put({ type: FETCH_PVS_BRAND_FAILURE, payload: { message } })
  }
}

/* ALL BAZAAR LIST */
export function* getBazaarListWorker(action) {
  try {
    const response = yield pvsApi.getBazaarList(
      action.payload.bazaarData,
      action.payload.token
    )
    console.log("getBazaarListWorker response:", response)

    if (response.status === 200) {
      yield put({
        type: ALL_BAZAAR_LIST_SUCCESS,
        payload: { bazaar: response.data.bazaar },
      })
    } else {
      yield put({ type: ALL_BAZAAR_LIST_FAILURE, payload: response.error })
    }
  } catch (error) {
    yield put({ type: ALL_BAZAAR_LIST_FAILURE, payload: error.message })
  }
}

export function* fetchStallListWorker(action) {
  console.log("fetchStallListWorker called with:", action)

  try {
    const response = yield pvsApi.fetchStallList(
      action.payload.data,
      action.payload.token
    )
    console.log("stall response", response)
    if (response.status === 200) {
      let successAction = {
        type: FETCH_STALL_LIST_SUCCESS,
        payload: {
          bazaarStallList: response.data.stall,
        },
      }
      yield put(successAction)
    } else if (response.status === 400) {
      console.log("error response", response)

      let failureAction = {
        type: FETCH_STALL_LIST_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("fetch stall list Error", error)
    let failureAction = {
      type: FETCH_STALL_LIST_FAILURE,
      payload: { msg: error.message || "fetch stall list failed" },
    }
    yield put(failureAction)
  }
}

export function* fetchPvsDetailsWorker(action) {
  try {
    const response = yield pvsApi.getPvsDetailsByPvsCardNumber(
      action.payload.pvsData,
      action.payload.token
    )
    console.log("pvs details response..", response.data)

    if (response.status === 200) {
      let successAction = {
        type: FETCH_PVS_DETAILS_SUCCESS,
        payload: {
          pvsDetails: response.data.data.pvs,
          message: response.data.message,
        },
      }
      yield put(successAction)
    } else if (response.status === 404) {
      console.log("error response", response)

      let failureAction = {
        type: FETCH_PVS_DETAILS_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("fetch pvs details Error", error)
    let failureAction = {
      type: FETCH_PVS_DETAILS_FAILURE,
      payload: { msg: error.message || "fetch pvs details failed" },
    }
    yield put(failureAction)
  }
}

export function* getBookingListWorker(action) {
  try {
    const response = yield pvsApi.getBookingList(
      action.payload.data,
      action.payload.token
    )
    console.log("booking list response..", response)

    if (response.status === 200) {
      let successAction = {
        type: GET_BOOKING_LIST_SUCCESS,
        payload: {
          bookings: response.data.registration,
        },
      }
      yield put(successAction)
    } else if (response.status === 404) {
      console.log("error response", response)

      let failureAction = {
        type: GET_BOOKING_LIST_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("get booking list Error", error)
    let failureAction = {
      type: GET_BOOKING_LIST_FAILURE,
      payload: { msg: error.message || "get booking list failed" },
    }
    yield put(failureAction)
  }
}

export function* submitBookingWorker(action) {
  try {
    const response = yield pvsApi.submitBooking(
      action.payload.data,
      action.payload.token
    )
    console.log("submit booking response..", response)

    if (response.status === 200) {
      let successAction = {
        type: SUBMIT_BOOKING_SUCCESS,
        payload: {
          message: response.data.message,
        },
      }
      yield put(successAction)
    } else if (
      response.status === 404 ||
      response.status === 400 ||
      response.status === 500
    ) {
      console.log("error response", response)

      let failureAction = {
        type: SUBMIT_BOOKING_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("submit booking Error", error)
    let failureAction = {
      type: SUBMIT_BOOKING_FAILURE,
      payload: { msg: error.message || "submit booking failed" },
    }
    yield put(failureAction)
  }
}

export function* fetchBookingDetailsWorker(action) {
  try {
    const response = yield pvsApi.fetchBookingDetails(
      action.payload.data,
      action.payload.token
    )
    console.log("fetch booking details response..", response)

    if (response.status === 200) {
      let successAction = {
        type: FETCH_BOOKING_DETAILS_SUCCESS,
        payload: {
          bookingInfo: response.data.data,
        },
      }
      yield put(successAction)
    } else if (response.status === 404) {
      console.log("error response", response)

      let failureAction = {
        type: FETCH_BOOKING_DETAILS_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("submit booking Error", error)
    let failureAction = {
      type: FETCH_BOOKING_DETAILS_FAILURE,
      payload: { msg: error.message || "submit booking failed" },
    }
    yield put(failureAction)
  }
}

export function* addBookingPaymentWorker(action) {
  try {
    const response = yield pvsApi.addBookingPayment(
      action.payload.data,
      action.payload.token
    )
    console.log("booking payment response..", response)

    if (response.status === 200) {
      let successAction = {
        type: ADD_BOOKING_PAYMENT_SUCCESS,
        payload: {
          message: response.data.message,
        },
      }
      yield put(successAction)
    } else if (
      response.status === 404 ||
      response.status === 400 ||
      response.status === 500
    ) {
      console.log("error response", response)

      let failureAction = {
        type: ADD_BOOKING_PAYMENT_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("booking payment Error", error)
    let failureAction = {
      type: ADD_BOOKING_PAYMENT_FAILURE,
      payload: { error: error.message || "booking payment failed" },
    }
    yield put(failureAction)
  }
}

export function* resendInvoiceWorker(action) {
  try {
    const response = yield pvsApi.resendInvoice(
      action.payload.data,
      action.payload.token
    )
    console.log("resend invoice response..", response)

    if (response.status === 200) {
      let successAction = {
        type: RESEND_INVOICE_SUCCESS,
        payload: {
          message: response.data.message,
        },
      }
      yield put(successAction)
    } else if (response.status === 404 || response.status === 400) {
      console.log("error response", response)

      let failureAction = {
        type: RESEND_INVOICE_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("resend invoice Error", error)
    let failureAction = {
      type: RESEND_INVOICE_FAILURE,
      payload: { error: error.message || "resend invoice failed" },
    }
    yield put(failureAction)
  }
}

export function* getUserBillingInfoWorker(action) {
  try {
    const response = yield pvsApi.getUserBillingInfo(
      action.payload.data,
      action.payload.token
    )
    console.log("get user billing info response..", response)

    if (response.status === 200) {
      let successAction = {
        type: GET_USER_BILLING_INFO_SUCCESS,
        payload: {
          message: response.data.message,
          billingInfo: response.data.data,
        },
      }
      yield put(successAction)
    } else if (response.status === 404 || response.status === 400) {
      console.log("error response", response)

      let failureAction = {
        type: GET_USER_BILLING_INFO_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("get user billing info Error", error)
    let failureAction = {
      type: GET_USER_BILLING_INFO_FAILURE,
      payload: { error: error.message || "get user billing info failed" },
    }
    yield put(failureAction)
  }
}

export function* regenerateInvoiceWorker(action) {
  try {
    const response = yield pvsApi.regenerateInvoice(
      action.payload.data,
      action.payload.token
    )
    console.log("regenerate invoice response..", response)

    if (response.status === 200) {
      let successAction = {
        type: REGENERATE_INVOICE_SUCCESS,
        payload: {
          message: response.data.message,
        },
      }
      yield put(successAction)
    } else if (response.status === 404 || response.status === 400) {
      console.log("error response", response)

      let failureAction = {
        type: REGENERATE_INVOICE_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("regenerate invoice Error", error)
    let failureAction = {
      type: REGENERATE_INVOICE_FAILURE,
      payload: { error: error.message || "regenerate invoice failed" },
    }
    yield put(failureAction)
  }
}

export function* downloadInvoicesWorker(action) {
  try {
    const response = yield pvsApi.downloadInvoices(
      action.payload.data,
      action.payload.token
    )
    console.log("download invoices response..", response)

    if (response.status === 200) {
      let successAction = {
        type: DOWNLOAD_INVOICES_SUCCESS,
        payload: {
          message: response.data.message,
          invoicesZipFileLink: response.data.zip_url,
        },
      }
      yield put(successAction)
    } else if (response.status === 404 || response.status === 400) {
      console.log("error response", response)

      let failureAction = {
        type: DOWNLOAD_INVOICES_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("download invoices Error", error)
    let failureAction = {
      type: DOWNLOAD_INVOICES_FAILURE,
      payload: { error: error.message || "download invoices failed" },
    }
    yield put(failureAction)
  }
}

export function* getBazaarStallDetailsWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield pvsApi.getBazaarStallDetails(
      action.payload.data,
      token
    )
    console.log("get bazaar stall details response..", response)

    if (response.status === 200) {
      let successAction = {
        type: GET_BAZAAR_STALL_DETAILS_SUCCESS,
        payload: {
          message: response.data.message,
          stallDetails: response.data.data,
        },
      }
      yield put(successAction)
    } else if (response.status === 404 || response.status === 400) {
      console.log("error response", response)

      let failureAction = {
        type: GET_BAZAAR_STALL_DETAILS_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("get bazaar stall details Error", error)
    let failureAction = {
      type: GET_BAZAAR_STALL_DETAILS_FAILURE,
      payload: { error: error.message || "get bazaar stall details failed" },
    }
    yield put(failureAction)
  }
}

export function* updateBazaarStallDetailsWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield pvsApi.updateBazaarStallDetails(
      action.payload.data,
      token
    )
    console.log("update bazaar stall details response..", response)

    if (response.status === 200) {
      let successAction = {
        type: UPDATE_BAZAAR_STALL_DETAILS_SUCCESS,
        payload: {
          message: response.data.message,
          stallDetails: response.data.data,
        },
      }
      yield put(successAction)
    } else if (response.status === 404 || response.status === 400) {
      console.log("error response", response)

      let failureAction = {
        type: UPDATE_BAZAAR_STALL_DETAILS_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("update bazaar stall details Error", error)
    let failureAction = {
      type: UPDATE_BAZAAR_STALL_DETAILS_FAILURE,
      payload: { error: error.message || "update bazaar stall details failed" },
    }
    yield put(failureAction)
  }
}

export function* addBazaarStallDetailsWorker(action) {
  console.log("addBazaarStallDetailsWorker invoked")

  try {
    const token = yield select(getAuthToken)
    const response = yield pvsApi.addBazaarStallDetails(
      action.payload.data,
      token
    )
    console.log("add bazaar stall details response..", response)

    if (response.status === 200) {
      let successAction = {
        type: ADD_BAZAAR_STALL_DETAILS_SUCCESS,
        payload: {
          message: response.data.message,
          stallDetails: response.data.data,
        },
      }
      yield put(successAction)
    } else if (response.status === 404 || response.status === 400) {
      console.log("error response", response)

      let failureAction = {
        type: ADD_BAZAAR_STALL_DETAILS_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("add bazaar stall details Error", error)
    let failureAction = {
      type: ADD_BAZAAR_STALL_DETAILS_FAILURE,
      payload: { error: error.message || "add bazaar stall details failed" },
    }
    yield put(failureAction)
  }
}

export function* addBazaarWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield pvsApi.addBazaar(action.payload.data, token)
    console.log("add bazaar response..", response)

    if (response.status === 200) {
      let successAction = {
        type: ADD_BAZAAR_SUCCESS,
        payload: {
          message: response.data.message,
        },
      }
      yield put(successAction)
    } else if (response.status === 404 || response.status === 400) {
      console.log("error response", response)

      let failureAction = {
        type: ADD_BAZAAR_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("add bazaar Error", error)
    let failureAction = {
      type: ADD_BAZAAR_FAILURE,
      payload: { error: error.message || "add bazaar failed" },
    }
    yield put(failureAction)
  }
}

export function* cancelStallBookingWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield pvsApi.cancelStallBooking(action.payload.data, token)
    console.log("cancel stall booking response..", response)

    if (response.status === 200) {
      let successAction = {
        type: CANCEL_STALL_BOOKING_SUCCESS,
        payload: {
          message: response.data.message,
        },
      }
      yield put(successAction)
    } else if (
      response.status === 404 ||
      response.status === 400 ||
      response.status === 500
    ) {
      console.log("error response", response)

      let failureAction = {
        type: CANCEL_STALL_BOOKING_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("cancel stall booking Error", error)
    let failureAction = {
      type: CANCEL_STALL_BOOKING_FAILURE,
      payload: { error: error.message || "cancel stall booking failed" },
    }
    yield put(failureAction)
  }
}

export function* getPaymentStatisticsWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield pvsApi.getPaymentStatistics(
      action.payload.data,
      token
    )
    console.log("get payment statistics response..", response)

    if (response.status === 200) {
      let successAction = {
        type: GET_PAYMENT_STATISTICS_SUCCESS,
        payload: {
          message: response.data.message,
          paymentStatistics: response.data,
        },
      }
      yield put(successAction)
    } else if (
      response.status === 404 ||
      response.status === 400 ||
      response.status === 500
    ) {
      console.log("error response", response)

      let failureAction = {
        type: GET_PAYMENT_STATISTICS_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("get payment statistics Error", error)
    let failureAction = {
      type: GET_PAYMENT_STATISTICS_FAILURE,
      payload: { error: error.message || "get payment statistics failed" },
    }
    yield put(failureAction)
  }
}

/* Product Workers */
export function* fetchProductsWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield pvsApi.fetchProducts(token)
    console.log("fetch products response..", response)

    if (response.status === 200) {
      let successAction = {
        type: FETCH_PRODUCTS_SUCCESS,
        payload: {
          products: response.data.products,
          message: response.data.message,
        },
      }
      yield put(successAction)
    } else if (
      response.status === 404 ||
      response.status === 400 ||
      response.status === 500
    ) {
      console.log("error response", response)

      let failureAction = {
        type: FETCH_PRODUCTS_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("fetch products Error", error)
    let failureAction = {
      type: FETCH_PRODUCTS_FAILURE,
      payload: { error: error.message || "fetch products failed" },
    }
    yield put(failureAction)
  }
}

export function* createProductWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield pvsApi.createProduct(action.payload.data, token)
    console.log("create product response..", response)

    if (response.status === 200 || response.status === 201) {
      let successAction = {
        type: CREATE_PRODUCT_SUCCESS,
        payload: {
          message: response.data.message,
          product: response.data.product,
        },
      }
      yield put(successAction)
    } else if (
      response.status === 404 ||
      response.status === 400 ||
      response.status === 500
    ) {
      console.log("error response", response)

      let failureAction = {
        type: CREATE_PRODUCT_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("create product Error", error)
    let failureAction = {
      type: CREATE_PRODUCT_FAILURE,
      payload: { error: error.message || "create product failed" },
    }
    yield put(failureAction)
  }
}

export function* updateProductWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield pvsApi.updateProduct(
      action.payload.data,
      token
    )
    console.log("update product response..", response)

    if (response.status === 200) {
      let successAction = {
        type: UPDATE_PRODUCT_SUCCESS,
        payload: {
          message: response.data.message,
          product: response.data.product,
        },
      }
      yield put(successAction)
    } else if (
      response.status === 404 ||
      response.status === 400 ||
      response.status === 500
    ) {
      console.log("error response", response)

      let failureAction = {
        type: UPDATE_PRODUCT_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("update product Error", error)
    let failureAction = {
      type: UPDATE_PRODUCT_FAILURE,
      payload: { error: error.message || "update product failed" },
    }
    yield put(failureAction)
  }
}

export function* deleteProductWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield pvsApi.deleteProduct(action.payload, token)
    console.log("delete product response..", response)

    if (response.status === 200) {
      let successAction = {
        type: DELETE_PRODUCT_SUCCESS,
        payload: {
          message: response.data.message,
        },
      }
      yield put(successAction)
    } else if (
      response.status === 404 ||
      response.status === 400 ||
      response.status === 500
    ) {
      console.log("error response", response)

      let failureAction = {
        type: DELETE_PRODUCT_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("delete product Error", error)
    let failureAction = {
      type: DELETE_PRODUCT_FAILURE,
      payload: { error: error.message || "delete product failed" },
    }
    yield put(failureAction)
  }
}

export function* fetchProductDetailsWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield pvsApi.fetchProductDetails(action.payload.data, token)
    console.log("fetch product details response..", response)

    if (response.status === 200) {
      let successAction = {
        type: FETCH_PRODUCT_DETAILS_SUCCESS,
        payload: {
          productDetails: response.data.product,
          message: response.data.message,
        },
      }
      yield put(successAction)
    } else if (
      response.status === 404 ||
      response.status === 400 ||
      response.status === 500
    ) {
      console.log("error response", response)

      let failureAction = {
        type: FETCH_PRODUCT_DETAILS_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("fetch product details Error", error)
    let failureAction = {
      type: FETCH_PRODUCT_DETAILS_FAILURE,
      payload: { error: error.message || "fetch product details failed" },
    }
    yield put(failureAction)
  }
}
